import ModalsInfoLib from '../../lib/modals-info';

export default () => {
    return (
        <div className="modal-info-container">
            <div className="modal-info animate__animated animate__fadeInUp animate__faster">
                <div className="close-button" onClick={e => ModalsInfoLib.close()}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>

                <div className="modal-info-content">
                    <div className="modal-info-image">
                        <img src={`${window.location.origin}/source/system/modal-info/vip-20-deposit-assist-token-info.png`} alt="" />
                    </div>

                    <div className="modal-info-body">
                        <div className="modal-info-body-content">
                            <p>
                                <h1>Deposit Assist Token (DAT)</h1>

                                <span>Deposit Assist Token is a utility bonus that helps you complete a game deposit when your balance is slightly below the required minimum.</span>
                                <span>If you don’t have enough balance, DAT automatically covers the missing part so you can continue playing without interruption.</span>
                            </p>

                            <p>
                                <h2>Deposit Assist Token Values by VIP Level</h2>
                                <span>
                                    Bronze — <b>$0.5</b> (up to 3 tokens)<br/>
                                    Silver — <b>$1</b> (up to 2 tokens)<br/>
                                    Gold — <b>$1.5</b> (up to 2 tokens)<br/>
                                    Platinum — <b>$2</b> (up to 2 tokens)<br/>
                                    Diamond — <b>$2</b> (up to 2 tokens)<br/>
                                    Elite — <b>$2.5</b> (up to 2 tokens)<br/>
                                    <br/>
                                    (Regular level does not have access to Deposit Assist Tokens.)
                                </span>
                            </p>

                            <p>
                                <h2>How does DAT work?</h2>
                                <span>Deposit Assist Tokens are used automatically when you don’t have enough balance to complete a deposit during gameplay.</span>
                                <span>They cover only the missing part required to reach the minimum deposit amount.</span>
                                <span>If needed, multiple tokens can be used at once.</span>
                            </p>

                            <p>
                                <h2>Important Rules</h2>
                                <span>
                                    DAT activates only when you are slightly below the required deposit amount.<br/>
                                    Tokens are consumed fully, even if only part of their value is needed.<br/>
                                    If the difference is too large, available tokens will still be applied.<br/>
                                </span>
                            </p>

                            <p>
                                <h2>How can I earn Deposit Assist Tokens?</h2>
                                <span>You can earn DAT through crypto deposit activity and by completing VIP Missions.</span>
                            </p>

                            <p>
                                <h2>Does my VIP level affect DAT?</h2>
                                <span>Yes. Your VIP level determines your token value and the maximum number of tokens you can hold.</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal-info-overlay animate__animated animate__fadeIn animate__faster"></div>
        </div>
    )
}